import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';

export const RequiresPaidPlanToCancelDowngrade = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      heading={t('Cannot Cancel Downgrade')}
      buttonText={t('Close')}
      actionBtnColor={'blue'}
      leftBtn={null}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'To cancel this pending downgrade, you must first cancel the pending downgrade on the Kizen core platform plan.'
          )}
        </Typography>
      </div>
    </Modal>
  );
};
